// extracted by mini-css-extract-plugin
module.exports = {"reviewGrid":"ReviewSection_reviewGrid__JGF5n","buttonWrapper":"ReviewSection_buttonWrapper__eBP_a","showAllButton":"ReviewSection_showAllButton__K4Dw6"};
module.exports.__checksum = "ac23799906fd"
